export default __webpack_public_path__ + "static/Entenda0117-83aefce04c6b0e925a43f1c89ec1116b.jpg";